export enum ME_ENDPOINT_ROLES {
  influencer = 'influencer',
}
